// Navigates back to wherever the current game session was launched from.
// Launchers (homeworkPage, dailyTasksPage) write "returnTo" to sessionStorage before
// navigating into a game. This utility reads it, clears it, and navigates there.
// Falls back to `fallback` (default "/home") when no origin was recorded.
export function navigateReturn(navigate, fallback = "/home") {
  const dest = sessionStorage.getItem("returnTo") || fallback;
  sessionStorage.removeItem("returnTo");
  navigate(dest);
}
